<template>
	<div>
		<el-divider content-position="left" border-style="dotted">Filter</el-divider>
		<el-form :model="rekapFilter" label-width="auto" label-position="top" :disabled="downloading">
			<div class="row g-3">
				<div class="col-12 col-md-4">
					<el-form-item label="Jenis Pengguna" prop="user_presensi_type" class="mb-0">
						<el-select v-model="rekapFilter.user_presensi_type" placeholder="Pilih jenis pengguna" clearable>
							<el-option v-for="t in listUserType" :key="t.value" :label="t.label" :value="t.value" />
						</el-select>
					</el-form-item>
				</div>
				<div class="col-12 col-md-8">
					<el-form-item label="Tanggal" prop="tanggal" class="mb-0">
						<el-date-picker
							v-model="rekapFilter.tanggal"
							type="daterange"
							range-separator="s/d"
							format="DD MMMM YYYY"
							value-format="YYYY-MM-DD"
							start-placeholder="Tanggal Awal"
							end-placeholder="Tanggal Akhir" />
					</el-form-item>
				</div>
			</div>
			<div v-if="isPetugasPresensi" class="row row-cols-auto g-2 justify-content-end mt-3">
				<el-button @click="generateRekapPresensi" plain round type="info" icon="EditPen" :loading="downloading" :disabled="!rekapFilter.user_presensi_type || !rekapFilter.tanggal">
					Buat Rekapitulasi Presensi
				</el-button>
				<el-button @click="downloadRekapPresensi" round type="success" icon="Download" :loading="downloading" :disabled="!rekapFilter.user_presensi_type">
					Unduh Rekapitulasi Presensi
				</el-button>
			</div>
		</el-form>
		<el-divider border-style="dotted" />
		<div v-if="rekapFilter.user_presensi_type">
			<transition name="fade" mode="out-in">
				<div v-if="rekapFilter.user_presensi_type === 'guru'">
					<div class="row g-2 justify-content-end mb-3">
						<div class="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4">
							<el-input v-model="searchKey" placeholder="Cari . . ." prefix-icon="Search" clearable />
						</div>
					</div>
					<el-table :data="rekapPresensi" row-key="guru_id" table-layout="auto" stripe v-loading="loading">
						<template #empty>
							<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
						</template>
						<el-table-column fixed type="index" label="No." :index="indexMethod" align="center" />
						<el-table-column fixed label="Nama" prop="nama" header-align="center">
							<template #default="{ row }">
								<div class="hstack gap-1 justify-content-between">
									<span>{{ row.nama }}</span>
									<el-tooltip content="Lihat detail rekap" placement="right">
										<el-button type="info" text plain icon="InfoFilled" @click="showDetail(row)" class="p-0" />
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="ID Presensi" prop="user_presensi_id" align="center">
							<template #default="{ row }">
								<transition name="fade" mode="out-in">
									<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
								</transition>
							</template>
						</el-table-column>
						<el-table-column label="Terjadwal" prop="terjadwal" align="center">
							<template #default="{ row }">
								{{ row.terjadwal ? row.terjadwal + " hari" : "-" }}
							</template>
						</el-table-column>
						<el-table-column label="Masuk" align="center">
							<el-table-column label="Tepat" prop="tepat_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Terlambat" prop="terlambat_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Tidak Presensi" prop="tidak_presensi_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Sakit" prop="sakit_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi_masuk" align="center" :formatter="formatterKali" />
						</el-table-column>
						<el-table-column label="Pulang" align="center">
							<el-table-column label="Tepat" prop="tepat_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Lebih Cepat" prop="pulang_cepat" align="center" :formatter="formatterKali" />
							<el-table-column label="Tidak Presensi" prop="tidak_presensi_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Sakit" prop="sakit_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi_pulang" align="center" :formatter="formatterKali" />
						</el-table-column>
						<el-table-column label="Tidak Masuk" align="center">
							<el-table-column label="Sakit" prop="sakit" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi" align="center" :formatter="formatterKali" />
							<el-table-column label="Cuti" prop="cuti" align="center" :formatter="formatterKali" />
							<el-table-column label="Dispensasi" prop="dispensasi" align="center" :formatter="formatterKali" />
							<el-table-column label="Tanpa Keterangan" prop="tanpa_keterangan" align="center" :formatter="formatterKali" />
						</el-table-column>
					</el-table>
				</div>
				<div v-else-if="rekapFilter.user_presensi_type === 'karyawan'">
					<div class="row g-2 justify-content-end mb-3">
						<div class="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4">
							<el-input v-model="searchKey" placeholder="Cari . . ." prefix-icon="Search" clearable />
						</div>
					</div>
					<el-table :data="rekapPresensi" row-key="karyawan_id" table-layout="auto" stripe v-loading="loading">
						<template #empty>
							<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
						</template>
						<el-table-column fixed type="index" label="No." :index="indexMethod" align="center" />
						<el-table-column fixed label="Nama" prop="nama" header-align="center">
							<template #default="{ row }">
								<div class="hstack gap-1 justify-content-between">
									<span>{{ row.nama }}</span>
									<el-tooltip content="Lihat detail rekap" placement="right">
										<el-button type="info" text plain icon="InfoFilled" @click="showDetail(row)" class="p-0" />
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="ID Presensi" prop="user_presensi_id" align="center">
							<template #default="{ row }">
								<transition name="fade" mode="out-in">
									<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
								</transition>
							</template>
						</el-table-column>
						<el-table-column label="Terjadwal" prop="terjadwal" align="center">
							<template #default="{ row }">
								{{ row.terjadwal ? row.terjadwal + " hari" : "-" }}
							</template>
						</el-table-column>
						<el-table-column label="Masuk" align="center">
							<el-table-column label="Tepat" prop="tepat_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Terlambat" prop="terlambat_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Tidak Presensi" prop="tidak_presensi_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Sakit" prop="sakit_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi_masuk" align="center" :formatter="formatterKali" />
						</el-table-column>
						<el-table-column label="Pulang" align="center">
							<el-table-column label="Tepat" prop="tepat_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Lebih Cepat" prop="pulang_cepat" align="center" :formatter="formatterKali" />
							<el-table-column label="Tidak Presensi" prop="tidak_presensi_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Sakit" prop="sakit_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi_pulang" align="center" :formatter="formatterKali" />
						</el-table-column>
						<el-table-column label="Tidak Masuk" align="center">
							<el-table-column label="Sakit" prop="sakit" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi" align="center" :formatter="formatterKali" />
							<el-table-column label="Cuti" prop="cuti" align="center" :formatter="formatterKali" />
							<el-table-column label="Dispensasi" prop="dispensasi" align="center" :formatter="formatterKali" />
							<el-table-column label="Tanpa Keterangan" prop="tanpa_keterangan" align="center" :formatter="formatterKali" />
						</el-table-column>
					</el-table>
				</div>
				<div v-else>
					<div class="row g-2 justify-content-end mb-3">
						<div class="col-12 col-sm-5 col-md-4 col-lg-3 col-xl-2">
							<el-select v-model="rekapFilter.rombel_id" filterable placeholder="Rombel" clearable>
								<el-option v-for="r in listRombel" :key="r.rombel_id" :label="r.nama" :value="r.rombel_id" />
							</el-select>
						</div>
						<div class="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4">
							<el-input v-model="searchKey" placeholder="Cari . . ." prefix-icon="Search" clearable />
						</div>
					</div>
					<el-table :data="rekapPresensi" row-key="siswa_id" table-layout="auto" stripe v-loading="loading">
						<template #empty>
							<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
						</template>
						<el-table-column fixed type="index" label="No." :index="indexMethod" align="center" />
						<el-table-column fixed label="Nama" prop="nama" header-align="center">
							<template #default="{ row }">
								<div class="hstack gap-1 justify-content-between">
									<span>{{ row.nama }}</span>
									<el-tooltip content="Lihat detail rekap" placement="right">
										<el-button type="info" text plain icon="InfoFilled" @click="showDetail(row)" class="p-0" />
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="ID Presensi" prop="user_presensi_id" align="center">
							<template #default="{ row }">
								<transition name="fade" mode="out-in">
									<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
								</transition>
							</template>
						</el-table-column>
						<el-table-column label="NIS" prop="nis" align="center" />
						<el-table-column label="Rombel" prop="nama_rombel" align="center" />
						<el-table-column label="Status" prop="singkatan_status" align="center" />
						<el-table-column label="Terjadwal" prop="terjadwal" align="center">
							<template #default="{ row }">
								{{ row.terjadwal ? row.terjadwal + " hari" : "-" }}
							</template>
						</el-table-column>
						<el-table-column label="Masuk" align="center">
							<el-table-column label="Tepat" prop="tepat_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Terlambat" prop="terlambat_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Tidak Presensi" prop="tidak_presensi_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Sakit" prop="sakit_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas_masuk" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi_masuk" align="center" :formatter="formatterKali" />
						</el-table-column>
						<el-table-column label="Pulang" align="center">
							<el-table-column label="Tepat" prop="tepat_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Lebih Cepat" prop="pulang_cepat" align="center" :formatter="formatterKali" />
							<el-table-column label="Tidak Presensi" prop="tidak_presensi_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Sakit" prop="sakit_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas_pulang" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi_pulang" align="center" :formatter="formatterKali" />
						</el-table-column>
						<el-table-column label="Tidak Masuk" align="center">
							<el-table-column label="Sakit" prop="sakit" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Dinas" prop="izin_dinas" align="center" :formatter="formatterKali" />
							<el-table-column label="Izin Pribadi" prop="izin_pribadi" align="center" :formatter="formatterKali" />
							<el-table-column label="Cuti" prop="cuti" align="center" :formatter="formatterKali" />
							<el-table-column label="Dispensasi" prop="dispensasi" align="center" :formatter="formatterKali" />
							<el-table-column label="Tanpa Keterangan" prop="tanpa_keterangan" align="center" :formatter="formatterKali" />
						</el-table-column>
					</el-table>
				</div>
			</transition>

			<el-pagination
				class="flex-wrap justify-content-center mt-3"
				v-model:current-page="currentPage"
				v-model:page-size="pageSize"
				:page-sizes="[5, 10, 25, 50, 100]"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalData"
				@change="getRekapPresensi" />
		</div>

		<el-dialog ref="dialogDetail" v-model="dialogDetailVisible" :title="dialogTitle" :width="modalWidth" draggable align-center @closed="showDetail">
			<el-table :data="detailRekapPresensi" max-height="400" table-layout="auto" @scroll="handleScrollDetail" class="table-detail-rekap" v-loading="loadingDetail">
				<template #empty>
					<span>{{ loadingDetail ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" fixed label="No." />
				<el-table-column label="Hari/Tanggal" fixed prop="tanggal" :formatter="formatterDetail" />
				<el-table-column label="Jadwal Masuk" prop="jam_mulai" :formatter="formatterDetail" />
				<el-table-column label="Jadwal Pulang" prop="jam_selesai" :formatter="formatterDetail" />
				<el-table-column label="Presensi Masuk" prop="waktu_masuk" :formatter="formatterDetail" />
				<el-table-column label="Presensi Pulang" prop="waktu_pulang" :formatter="formatterDetail" />
				<el-table-column label="Tidak Masuk" prop="tidak_hadir" :formatter="formatterDetail" />
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "RekapPresensi",
	data() {
		return {
			rekapPresensi: [],
			totalDetailRekap: 0,
			listUserType: [
				{ label: "Guru", value: "guru" },
				{ label: "Tenaga Kependidikan", value: "karyawan" },
				{ label: "Siswa", value: "siswa" },
			],
			listRombel: [],
			rekapFilter: {
				user_presensi_type: null,
				rombel_id: null,
				tanggal: null,
			},
			rowShowedDetail: null,
			dialogTitle: null,
			modalWidth: "50%",
			dialogDetailVisible: false,
			detailRekapPresensi: [],
			searchKey: null,
			debounceFetch: null,
			debounceFetchDetail: null,
			generating: false,
			loading: false,
			loadingDetail: false,
			downloading: false,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		isPetugasPresensi: Boolean,
	},
	computed: {},
	watch: {
		"rekapFilter.user_presensi_type"() {
			clearTimeout(this.debounceFetch);
			this.rekapFilter.rombel_id = null;
			this.searchKey = null;

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"rekapFilter.rombel_id"() {
			clearTimeout(this.debounceFetch);
			this.searchKey = null;

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"rekapFilter.tanggal"(newVal, oldVal) {
			if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

			clearTimeout(this.debounceFetch);
			this.searchKey = null;

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		searchKey() {
			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 500);
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		this.$ws.main.on("user:guru:updated", this.updatedUserGuru);
		this.$ws.main.on("user:karyawan:updated", this.updatedUserKaryawan);
		this.$ws.main.on("user:siswa:updated", this.updatedUserSiswa);
		this.$ws.main.on("rekap:generated", this.generatedRekap);
		this.getListRombel();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		this.$ws.main.off("user:guru:updated");
		this.$ws.main.off("user:karyawan:updated");
		this.$ws.main.off("user:siswa:updated");
		this.$ws.main.off("rekap:generated");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		formatterKali(row, col, val) {
			return val ? val + " kali" : "-";
		},
		formatterDetail(row, col, val) {
			if (col.property === "tanggal") {
				const tgl = new Date(val).toLocaleDateString("id-ID", { dateStyle: "full" });
				return tgl;
			}
			if (col.property === "waktu_masuk") {
				if (val) return `${val} (${row.status_masuk})`;
				if (!val && row.status_masuk) return row.status_masuk;
				return "-";
			}
			if (col.property === "waktu_pulang") {
				if (val) return `${val} (${row.status_pulang})`;
				if (!val && row.status_pulang) return row.status_pulang;
				return "-";
			}
			if (!val) return "-";
			return val;
		},
		updatedUserGuru(data) {
			if (this.rekapFilter.user_presensi_type !== "guru") return;
			const d = JSON.parse(data);

			this.rekapPresensi.every((l) => {
				if (l.guru_id === d.guru_id) {
					if (d.user_presensi_id) l.user_presensi_id = d.user_presensi_id;

					return false;
				}
				return true;
			});
		},
		updatedUserKaryawan(data) {
			if (this.rekapFilter.user_presensi_type !== "karyawan") return;
			const d = JSON.parse(data);

			this.rekapPresensi.every((l) => {
				if (l.karyawan_id === d.karyawan_id) {
					if (d.user_presensi_id) l.user_presensi_id = d.user_presensi_id;

					return false;
				}
				return true;
			});
		},
		updatedUserSiswa(data) {
			if (this.rekapFilter.user_presensi_type !== "siswa") return;
			const d = JSON.parse(data);

			this.rekapPresensi.every((l) => {
				if (l.siswa_id === d.siswa_id) {
					if (d.user_presensi_id) l.user_presensi_id = d.user_presensi_id;

					return false;
				}
				return true;
			});
		},
		generatedRekap(data) {
			const d = JSON.parse(data);
			if (d.user_presensi_type !== this.rekapFilter.user_presensi_type) return;
			if (Array.isArray(this.rekapFilter.tanggal)) {
				const tglAwal = this.toWIB(d.tanggal_awal);
				const tglAkhir = this.toWIB(d.tanggal_akhir);
				const awal = new Date(this.rekapFilter.tanggal[0] + "T00:00:00+07:00");
				const akhir = new Date(this.rekapFilter.tanggal[1] + "T23:59:59.999+07:00");

				if (tglAkhir < awal || tglAwal > akhir) return;
			}

			this.getRekapPresensi();
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "95%";
			else if (w < 768) this.modalWidth = "85%";
			else if (w < 992) this.modalWidth = "75%";
			else if (w < 1200) this.modalWidth = "70%";
			else if (w < 1500) this.modalWidth = "65%";
			else if (w < 1920) this.modalWidth = "55%";
			else this.modalWidth = "50%";
		},
		async getListRombel() {
			try {
				const { data } = await this.$defaultApi.post("/user/list/rombel", {});

				this.listRombel = data.list_rombel;
			} catch (error) {
				console.error(error);
			}
		},
		async getRekapPresensi() {
			if (!this.rekapFilter.user_presensi_type) return;

			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/rekap", {
					user_presensi_type: this.rekapFilter.user_presensi_type,
					key: this.searchKey,
					rombel_id: this.rekapFilter.rombel_id,
					tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : null,
					tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : null,
					limit: this.pageSize,
					offset: (this.currentPage - 1) * this.pageSize,
				});

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.rekapPresensi = data.rekap;
				this.totalData = data.count;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		showDetail(row = null) {
			if (row) {
				if (this.rekapFilter.user_presensi_type === "siswa") {
					this.dialogTitle = `Detail Rekap Presensi · ${row.nama_rombel} · ${row.nis} · ${row.nama}`;
				} else {
					this.dialogTitle = `Detail Rekap Presensi · ${row.nama}`;
				}

				this.dialogDetailVisible = true;
				this.rowShowedDetail = row;
				this.getDetailRekapPresensi();
			} else {
				this.rowShowedDetail = null;
				this.dialogTitle = "Detail Rekap Presensi";
				this.$refs.dialogDetail.resetPosition();
				this.detailRekapPresensi = [];
				this.totalDetailRekap = 0;
			}
		},
		handleScrollDetail(e) {
			const table = document.querySelector(".table-detail-rekap");
			if (!table) return;

			const nearBottom = e.scrollTop + table.clientHeight >= table.scrollHeight - 50;

			if (nearBottom && this.detailRekapPresensi.length < this.totalDetailRekap) {
				clearTimeout(this.debounceFetchDetail);

				this.debounceFetchDetail = setTimeout(() => {
					this.getDetailRekapPresensi();
				}, 500);
			}
		},
		async getDetailRekapPresensi() {
			this.loadingDetail = true;
			try {
				const { data } = await this.$defaultApi.post("/rekap/detail", {
					user_presensi_type: this.rekapFilter.user_presensi_type,
					guru_id: this.rowShowedDetail.guru_id || null,
					karyawan_id: this.rowShowedDetail.karyawan_id || null,
					siswa_id: this.rowShowedDetail.siswa_id || null,
					tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : null,
					tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : null,
					limit: 25,
					offset: this.detailRekapPresensi.length,
				});

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.detailRekapPresensi = this.detailRekapPresensi.concat(data.detail_rekap);
				this.totalDetailRekap = data.count;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loadingDetail = false;
			}
		},
		async generateRekapPresensi() {
			this.generating = true;
			try {
				const { data } = await this.$defaultApi.post("/rekap/generate", {
					user_presensi_type: this.rekapFilter.user_presensi_type,
					tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : null,
					tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : null,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.generating = false;
			}
		},
		async downloadRekapPresensi() {
			this.downloading = true;
			try {
				const { data, headers } = await this.$defaultApi.post(
					"/rekap/download",
					{
						user_presensi_type: this.rekapFilter.user_presensi_type,
						key: this.searchKey,
						rombel_id: this.rekapFilter.rombel_id,
						tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : null,
						tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : null,
					},
					{
						responseType: "blob",
					}
				);

				const contentDisposition = headers["content-disposition"];
				let fileName = "RekapitulasiPresensi.xlsx";

				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						fileName = decodeURIComponent(match[1]);
					}
				}

				const url = window.URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

				const a = document.createElement("a");
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);

				await new Promise((resolve) => setTimeout(resolve, 500));
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.downloading = false;
			}
		},
	},
};
</script>

<style scoped></style>
